/**
    商品列表
**/
<template>
        <div class="rightaside_content">
          <h3 class="headerTitle">订单详情</h3>
          <div class="headerButton">
              <span style="line-height: 28px;">订单号：<i>{{orderObj.orderNumber||'--'}}</i></span>
              <div v-if="iscancle?false:true">
                <el-button  v-if="orderObj.status == 1?true:false" class="buttonStyle dangerBg" size="mini" @click="showDialog()">继续支付</el-button>
<!--                <el-button v-if=" orderObj.status == 1?true:false" size="mini" @click="cancleOrder(orderObj.oid)">取消订单</el-button>-->
                <el-button class="buttonStyle dangerBg"  size="mini" @click="down(orderObj.oid)">导出商品</el-button>
                <el-button class="buttonStyle dangerBg" size="mini" @click="showPayLog(orderObj)">支付记录</el-button>
                <el-button v-if="orderObj.status==3?true:false" class="buttonStyle dangerBg" size="mini" @click="confirmRceipt(orderObj)">确认收货</el-button>
              </div>
          </div>
          <el-divider></el-divider>
          <el-row class="order_goods">
            <span class="order_money">总金额：<i >{{ (orderObj.amount || 0).toFixed(2) }}</i> 元</span>
            <div><span class="order_money">已支付：<i >{{ (orderObj.paidAmount || 0).toFixed(2) }}</i> 元</span></div>
            <div><span class="unPaid_money">未支付：<i >{{ (orderObj.amount - orderObj.paidAmount|| 0).toFixed(2) }}</i> 元</span></div>
          </el-row>
          <div>
            <!-- 等待买家付款 -->
            <el-row class="order_goods">
              <el-col :span="24" class="info_title">{{(orderObj.groupStatus&&orderList.groupStatus!=2)?'拼团中': orderStatus(orderObj.status)}}</el-col>
              <el-col :span="24"  class="info_content">
                <p>下单时间： {{orderObj.createTime}}</p>
<!--                <p>付款时间： {{orderObj.payTime||'0000-00-00 00 ：00 ：00'}}</p>-->
                <p v-if="orderObj.onlineOrOffline == 2" style="display: flex;align-items: center">打款凭证： <el-image v-if="orderObj.paymentVoucher != null && orderObj.paymentVoucher != ''" @click="previewPicture(orderObj.paymentVoucher)" style="width: 100px;height: 50px;" :src="orderObj.paymentVoucher"></el-image></p>
                <p v-if="orderObj.onlineOrOffline == 2">审核备注： {{orderObj.orderVerifyRemark}}</p>
              </el-col>
            </el-row>
            <!-- 备注 -->
            <el-row class="order_goods" v-if=" orderObj.orderRemark !== '' || orderObj.orderRemark!=null">
              <el-col :span="24" class="info_title">备注</el-col>
              <el-col :span="24"  class="info_content">
                <p>订单备注: {{orderObj.orderRemark}}</p>
              </el-col>
            </el-row>
            <!-- 收货信息 -->
            <el-row class="order_goods" v-if="orderObj.bXyShoppingAddress!=null">
              <el-col :span="24" class="info_title">收货信息</el-col>
              <el-col :span="24"  class="info_content">
                <p>姓名： {{orderObj.bXyShoppingAddress.recipient}}</p>
                <p>联系电话： {{orderObj.bXyShoppingAddress.phoneNumber}}</p>
                <p>收货地址： {{orderObj.areaName	}}/{{orderObj.bXyShoppingAddress.address}}</p>
                <p>物流单号： {{orderObj.logisticsNumber}}</p>
              </el-col>
            </el-row>
              <el-row class="order_goods">
                <el-col :span="24" class="info_title">订单商品</el-col>
                <el-table :data="commodityArr" border style="width: 100%" height="677" resizable ref="table" sum-text="合计" :summary-method="getSummaries"  show-summary>
                  <el-table-column align="center" label="编码" width="140">
                    <template slot-scope="scope">
                      {{scope.row.serialNumber != null ? scope.row.serialNumber : ''}}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="name" label="名称" width="290">
                    <template slot-scope="scope">
                      {{scope.row.commodityName}} {{scope.row.bxysName!=null  ?scope.row.bxysName:'默认规格'}}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" width="70" prop="level" label="等级">
                    <template slot-scope="scope">
                      {{levelText(scope.row.level)}}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" width="110" prop="buyprice" label="单价"></el-table-column>
                  <el-table-column align="center" width="60" prop="num" label="数量"></el-table-column>
                  <el-table-column align="center" prop="amount" label="总价">
                    <template slot-scope="scope">
                      {{scope.row.buyprice * scope.row.num}}
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>



                <!-- 物流信息 后期开发-->
<!--                <el-row class="order_goods" v-if='(orderObj.status==4 || orderObj.status==3)'>-->
<!--                    <el-col :span="24" class="info_title">物流信息</el-col>-->
<!--                    <el-col :span="24"  class="info_content">-->
<!--                        <p>物流公司： {{logistics_name}}</p>-->
<!--                        <p>运单号码： {{orderObj.logisticsNumber}}</p>-->
<!--                    </el-col>-->
<!--                    <el-col :span="24" v-if="deliver.length>0">-->
<!--                        <el-collapse v-model="activeName" accordion class="getLogistics">-->
<!--                            <el-collapse-item title="查看物流" name="1">-->
<!--                                <el-steps direction="vertical" :active="1">-->
<!--                                    <el-step icon="el-icon-position" v-for="(deliverItem,index) in  deliver" :key="index" :title="deliverItem.ftime" :description="deliverItem.context"></el-step>-->
<!--                                </el-steps>-->
<!--                            </el-collapse-item>-->
<!--                            </el-collapse>-->
<!--                    </el-col>-->
<!--                </el-row>-->


          </div>
          <el-dialog :visible.sync="dialogPictureVisible">
            <img width="500px;" :src="pictureSrc" alt="">
          </el-dialog>

          <!--  支付记录弹窗  -->
          <el-dialog title="支付记录" :visible.sync="dialogVisible" width="1338px">
            <el-table :data="payLogList" style="width: 100%;" border  show-summary :summary-method="getSummariesPayAmount">
              <el-table-column property="merOrderNo" label="支付单号" width="290" header-align="center" align="center"></el-table-column>
              <el-table-column property="amount" label="金额" width="170" header-align="center" align="center"></el-table-column>
              <el-table-column property="payAmount" label="支付金额" width="170" header-align="center" align="center"></el-table-column>
              <el-table-column property="payStatus" label="支付状态" header-align="center" align="center"
                               :filters="payStatusFilters"
                               :filter-method="filterPayStatus">
                <template slot-scope="scope">
                  <el-tag
                    :type="getStatusType(scope.row.payStatus)"
                    disable-transitions> {{ getStatusText(scope.row.payStatus) }}</el-tag>

                </template>
              </el-table-column>
              <el-table-column property="payTime" label="支付日期" width="170" header-align="center" align="center"></el-table-column>
              <el-table-column property="nickname" label="支付人" width="150" header-align="center" align="center"></el-table-column>
              <el-table-column property="createTime" label="创建日期" width="166" header-align="center" align="center"></el-table-column>
              <el-table-column property="payStatus"  label="操作" width="90" header-align="center" align="center">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.payStatus === 0"  size="small" type="success" @click="checkPaymentStatus(scope.row.merOrderNo, false)">已支付</el-button>
                </template>
              </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDialog()" class="buttonBgd">确 定</el-button>
      </span>
          </el-dialog>

          <!--     再次支付弹窗     -->
          <el-dialog
            title="确认支付"
            :visible.sync="payDialogVisible"
            width="30%"
            center>
            <div style="font-size: 14px; text-align: left; color: #78b942; margin-top: 10px;">
              <div style="background-color: #f0f9eb; border: 1px solid #e1f3d8; border-radius: 8px; padding: 10px;">
                <span style="color: red;"><strong>温馨提示：</strong></span>
                <br>
                1、订单支付状态同步可能会存在延时，如果支付成功，请稍后查看订单的支付状态
                <br>
                2、订单待支付金额如果小于银行卡单次支付限额的，可以直接填写订单待支付金额。
                <br>
                3、订单待支付金额如果大于银行卡单次支付限额的，请填写银行单次支付限额金额，分多次进行支付。
              </div>
            </div>
            <div style="font-size: 16px; text-align: left; padding: 0 20px; margin-top: 20px;">
              <div>
                <span><strong>待支付金额：</strong><i style="color: #d01717">{{ (orderObj.amount - orderObj.paidAmount || 0).toFixed(2) }}</i> 元</span>
              </div>
              <div style="margin-top: 18px; display: flex; align-items: center;">
                <span><strong>本次支付金额：</strong></span>
                <input type="number" v-model="payMoney" autocomplete="off" style="margin-left: 10px;">
              </div>
            </div>

            <span slot="footer" class="dialog-footer">
              <el-button @click="payDialogVisible = false">取 消</el-button>
              <el-button type="primary" class="buttonBgd" @click="payMoneyAgain()">确 定</el-button>
            </span>
          </el-dialog>
        </div>
</template>
<script>
import {downloadDevices} from '@/api/excel'
import {cancleOrderItem,onePricePay,kuaidi100,showorderDetail,payOrderList, auctionOrderDetail, checkPaymentStatus, confirmRceiptItem, orderCommodityPageList} from '@/api/xunyou'
export default {
  data() {
    return {
      payDialogVisible: false,
      dialogVisible: false,
      pictureSrc: '',
      dialogPictureVisible: false,
      logistics_name:'zhongtong', // 物流公司
      logistics_code:'zhongtong',
      deliver:[],// 物流信息
      iscancle:false,
      isremove:false,
      codeVisible:false,
      searchValue:'',
      orderInfoList:JSON.parse(sessionStorage.getItem("orderDetail")) || [],
      orderObj:{},
      logistics_number:0,
      sellCode:'', //核销码
      qrcode:'',
      totalMoney:0,
      commodityArr: [], // 商品列表
      payLogList: [], // 支付记录列表
      downUrl: '/custom/xunyou/web/auction/export',
      payMoney: 0, //支付金额
      uid: JSON.parse(localStorage.getItem("userdata")).userId,
      payStatusFilters: [
        { text: '待支付', value: 0 },
        { text: '未支付', value: 1 },
        { text: '已支付', value: 2 }
      ],
      orderItem:  {},
      // 分页参数
      pageparm:{
        pageSize:15,
        pageNum:1,
        total:0,
      },
      commodityAmount: 0, // 商品总价
      commodityNumber: 0, // 商品总数量
      loadingMore: false, // 是否正在加载更多数据
    }
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    const merOrderNo = this.$route.query.merOrderNo;
    if (merOrderNo) {
      this.showPaymentConfirmationDialog(merOrderNo);
    }
  },
  mounted(){
    this.getOrderDetail()
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 银联收银台支付完成后重定向当前页面
    showPaymentConfirmationDialog(merOrderNo) {
      this.$confirm('请确认您是否已经完成支付？', '支付确认', {
        confirmButtonText: '已支付',
        cancelButtonText: '未支付',
        type: 'info'
      }).then(() => {
        // 用户确认已支付
        this.checkPaymentStatus(merOrderNo, true);
      }).catch(() => {
        // 用户确认未支付或关闭模态框
        this.removeMerOrderNoAndRefresh();
      });
    },
    // 验证支付状态，手动触发查询支付订单状态
    checkPaymentStatus(merOrderNo, isAuto) {
      console.log('merOrderNo', merOrderNo)
      checkPaymentStatus({ merOrderNo:  merOrderNo  })
        .then(response => {
          console.log('response', response)
          if (response.code === 0) {
            this.$message.success('查询成功');
            if(isAuto) {
              this.refreshPage();
            }else {
              this.getPayLog(this.orderItem);
            }
          } else {
            this.$message.error('查询失败: ' + response.msg);
            this.refreshPage();
          }
        })
        .catch(error => {
          console.error('验证支付状态失败:', error);
          this.refreshPage();
        })
        .finally(() => {
            this.removeMerOrderNoAndRefresh();
          }
        );
    },
    // 移除 URL 中的 merOrderNo 参数并刷新页面
    removeMerOrderNoAndRefresh() {
      const query = { ...this.$route.query };
      delete query.merOrderNo;
      this.$router.replace({ query }).then(() => {
        this.refreshPage();
      });
    },
    // 刷新当前页面
    refreshPage() {
      this.$router.go(0);
    },

    previewPicture(src) {
      this.pictureSrc = src;
      this.dialogPictureVisible = true
    },

    //   查询订单详情
    getOrderDetail(){
      auctionOrderDetail({oid:this.$route.query.oid}).then(res=>{
            console.log(res)
            if(res.code===0){
              this.orderObj = res.data;
              this.commodityAmount = res.data.orderAmount
              this.commodityNumber = res.data.num
              this.orderCommodityPageList(res.data.oid)
            } else if(1 === parseInt(res.code)) {
              this.$router.push({path:'/login'})
            } else {
              this.$message.error(res.msg);
            }
        })
    },
    // 订单商品分页列表
    orderCommodityPageList(oid) {
      this.pageparm.oid = oid
      orderCommodityPageList(this.pageparm)
        .then(res => {
          if (res.code === 0) {
            this.commodityArr = res.rows
            this.pageparm.total = res.total;
            this.$nextTick(() => {
              console.log('表格重新渲染了');
              this.$refs['table'].doLayout();
            })
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          console.log('orderCommodityPageList fail', err)
          this.$message.error('查询订单商品失败，请稍后再试！')
        })
    },
    loadMore() {
      if (this.loadingMore || this.commodityArr.length >= this.pageparm.total) return;
      this.loadingMore = true;
      this.pageparm.pageNum += 1;
      orderCommodityPageList({
        oid: this.orderObj.oid,
        page: this.pageparm.pageNum,
        size: this.pageparm.pageSize
      }).then(res => {
        if (res.code === 0) {
          this.loadingMore = false;
          this.commodityArr = this.commodityArr.concat(res.rows);
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        console.log('loadMore fail', err);
        this.loadingMore = false;
        this.$message.error('加载更多数据失败，请稍后再试！');
      });
    },
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = document.documentElement.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= scrollHeight - 100 && !this.loadingMore) {
        this.loadMore();
      }
    },
    // 合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          // 只计算特定字段的合计
          if (column.property === 'num') {
            sums[index] = this.commodityNumber;
          } else if (column.property === 'amount') {
            sums[index] = `${this.commodityAmount.toFixed(2)} `;
          } else {
            sums[index] = '';
          }
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },

    // 合计支付弹窗的支付金额
    getSummariesPayAmount(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.property === 'payAmount') {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = `${parseFloat(sums[index].toFixed(2))} 元`;
          } else {
            sums[index] = '';
          }
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    //   B=零售,C=分销,D=拍卖,Z=待整理
    levelText(level){
      switch(level) {
        case 'B':
          return '零售'
          break;
        case 'C':
          return '分销'
          break;
        case 'D':
          return '拍卖'
          break;
        case 'Z':
          return '待整理'
          break;
        default:
          return '--'
      }
    },
    //   物流查询
    getTranspot(){
         kuaidi100({
            tracking_num: this.orderList.logisticsNumber!=null?this.orderList.logisticsNumber:'78164982674324',
			logistics_name: this.logistics_code // 后续改成变量
         }).then(res => {
                this.deliver = res.data||[]
                this.logisticsNumber = res.nu
                // this.logistics_name = res.com
                // })
            })
    },

      //   订单状态转换
    orderStatus(status){
        switch(status) {
            case 1:
                return '等待买家付款'
                break;
            case 2:
                 return '等待卖家发货'
                break;
            case 3:
                 return '等待买家确认收货'
                break;
            case 4:
                 return '交易成功'
                break;
            case 5:
                 return '交易关闭'
                break;
            case 11:
                 return '买家提交退单'
                break;
            case 12:
                 return '退单审核中'
                break;
            case 13:
                 return '等待卖家收货确认'
                break;
            case 14:
                 return '等待卖家退款确认'
                break;
            case 15:
                 return '等待买家收款确认'
                break;
            case 16:
                 return '退款退货完成'
                break;
            case 17:
                 return '已拒绝退款'
                break;
            case 18:
                 return '已取消'
                break;
            case 35:
              return '等待上传支付凭证'
              break;
            case 33:
              return '等待店铺审核支付凭证'
              break;
            case 34:
              return '店铺审核失败'
              break;
            default:
                return '--'
        }
    },
    getStatusType(payStatus) {
      switch (payStatus) {
        case 0:
          return 'danger'; // 你可以根据需要选择合适的类型
        case 2:
          return 'success';
        // 其他状态处理
        default:
          return 'info';
      }
    },
    // 支付记录状态
    getStatusText(status) {
      switch(status) {
        case 1:
          return '未支付'
          break;
        case 2:
          return '已支付'
          break;
        default:
          return '待支付'
      }
    },
    // 弹窗展示支付记录
    showPayLog(item) {
      this.dialogVisible = true;
      this.getPayLog(item);
      this.orderItem = item
    },
    closeDialog() {
      this.dialogVisible = false;
      this.orderItem = {}
    },
    // 获取支付记录
    getPayLog(item){
      payOrderList({orderNumber: item.orderNumber})
        .then(res => {
          if (res.code === 0) {
            this.loading = false
            this.payLogList = res.data;
          } else {
            console.error('orderLogList fail', res.msg)
          }
        })
        .catch(err => {
          console.log('orderLogList fail', err)
        })
    },
    filterPayStatus(value, row) {
      return row.payStatus === value;
    },
    // 弹窗展示支付记录
    showDialog() {
      this.payDialogVisible = true;
    },
    // 继续支付
    payMoneyAgain() {
      if(this.payMoney <= 0) {
        this.$message.error('请输入正确金额！')
        return
      }

      this.payMoney = parseFloat(this.payMoney).toFixed(2);
      this.loading = true
      console.log('继续支付金额', this.payMoney)

      // 获取当前页面的绝对路径
      const currentUrl = window.location.href + "&merOrderNo=";

      onePricePay({orderNumber: this.orderObj.orderNumber,
                  uid: this.uid,
                  price: this.payMoney,
                  upbcReturnUrl: currentUrl})
        .then(res => {
          if (res.code === 0) {
            this.loading = false
            this.payDialogVisible = false;
            // res.msg返回包含http，则执行重定向
            if (res.data.includes('http')) {
              // 重定向
              window.location.href = res.data;
            }
          } else if(1 === parseInt(res.code)) {
            this.$router.push({path:'/login'})
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          this.loading = false
          console.log('orderLogList fail', err)
        })
    },
      //   取消订单
     cancleOrder(orderId) {
        this.$confirm('确定取消订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
             cancleOrderItem({oid:orderId}).then(res => {
              if (res.code == 0) {
                this.$message({
                    type: 'success',
                    message: '取消成功!'
                });
                this.iscancle = true
                this.orderInfoList.status = 5
                sessionStorage.setItem("orderDetail", JSON.stringify([this.orderInfoList]));
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('取消失败，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },

    // 重新申请退款
    reApplyMoney(goodsItem){
        const myRefundInfo = {
                status:this.orderInfoList.status,
                oid:this.orderInfoList.oid,
                returnType:this.orderInfoList.status<=2?2:1,//1：需要退货，2.不用退货。 是否需要退货 没发货之前不需要退货
                orderNumber:this.orderInfoList.orderNumber,
                amount:this.orderInfoList.amount,
                goodsItem
            }
            sessionStorage.setItem('myRefundInfo',  JSON.stringify(myRefundInfo))
            this.$router.push('/myRefund?status=2')
    },

    // 退款
    reBackMoney(goodsItem,step){
        if(step==3){
            sessionStorage.setItem("orderDetail", JSON.stringify(goodsItem));
            this.$router.push('/refundDetail?refund=1')
        }else{
            const myRefundInfo = {
                status:this.orderInfoList.status,
                oid:this.orderInfoList.oid,
                returnType:this.orderInfoList.status<=2?2:1,//1：需要退货，2.不用退货。 是否需要退货 没发货之前不需要退货
                orderNumber:this.orderInfoList.orderNumber,
                amount:this.orderInfoList.amount,
                goodsItem
            }
            sessionStorage.setItem('myRefundInfo',  JSON.stringify(myRefundInfo))
            this.$router.push('/myRefund?status=1')
        }

    },
    //   导出订单
    down(id){
      const params  = {oid:id}
      downloadDevices('GET',this.downUrl+"/"+id,params).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/xlsx' }))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', 'saleOrder.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link) // 下载完成移除元素
        window.URL.revokeObjectURL(url) // 释放掉blob对象
      })
    },
    // 确认收货
    confirmRceipt(item){
      confirmRceiptItem({oid:item.oid,orderNumber:item.orderNumber}).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '确认收货成功!'
          });
          setTimeout(() => {
            this.refreshPage();
          }, 1000); // 延迟1秒执行
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
        .catch(err => {
          this.editFormVisible = false
          this.loading = false
          this.$message.error('确认收货失败，请稍后再试！')
        })
    },
  },
};
</script>

<style scoped lang="less">
    .rightaside_content{
        .el-divider--horizontal {
            display: block;
            height: 1px;
            width: 100%;
            margin: 5px 0;
        }
        .headerTitle{
            font-size: 20px;
            height: 40px;
            line-height: 40px;
            color: #666;
        }
        .headerButton {
            display: flex;
            justify-content: space-between;
            button.el-button.el-button--default.el-button--mini {
                // background: #78b942;
                // color: white;
                background: #f896521a;
                color: #78b942;
                border: 1px solid #78b942;
            }
            .el-button.el-button--mini:focus, .el-button.el-button--mini:hover {
                background: #78b942 !important;
                color: white !important;
            }
            button.el-button.buttonStyle {
              padding: 6px 30px;
              font-size: 12px;
              margin-bottom: 6px;
              margin-left: 0;
            }
          .dangerBg.buttonStyle{
            background-color:  #78b942;
            border-color:  #78b942;
          }
        }
        .order_goods.el-row {
            border-bottom: 1px solid#DCDFE6;
            padding: 20px 0 0 0;
            box-sizing: border-box;
            .order_Info_item {
                margin-left: 10px;
            }
            .getUser{
                cursor: pointer;
                color: #78b942;
            }
            .codeStyle{
                font-weight:bold
            }
            .codeUsedStyle{
                font-weight:bold;
                text-decoration: line-through;
            }

          .order_money i{
            font-size: 20px;
            color: #78b942;
          }
          .unPaid_money i{
            font-size: 20px;
            color: #e13c41;
          }
        }
        .info_title{
            margin: 0 0 15px;
            font-size: 16px;
            font-weight: 400;
            color: #333;
        }
        .info_content{
                color: #757575;
                p{
                    margin-bottom: 4px;
                }
        }
        .footer_total{
                text-align: right;
                color: #757575;
                p{
                    margin: 10px 0;
                }
                .footer_total_money{
                    color: #78b942;
                    .finalTotal{
                        font-size: 20px;
                    }
                }

        }
       button.el-button.reBackMoney.el-button--default.el-button--mini {
            background: #ff674c;
            color: white;
            border: 1px solid #ff674c;
        }
        button.el-button.reBackMoney.el-button--default.el-button--mini:hover {
            background: #f896521a;
            color:  #ff674c;
            border: 1px solid #ff674c;
        }

    }

// 查看物流
    .getLogistics{
       border-top:0px !important;
       border-bottom:0px !important;
       /deep/.el-collapse-item__header{
           border-bottom:0px !important;
           height:auto;
           line-height: inherit;
           color: coral;
           cursor: pointer;
           display:inline-block;
            margin: 10px 0;
       }
       /deep/.el-collapse-item__wrap{
           border-bottom:0px !important;
       }
       /deep/.el-step__icon{
           height: auto;
       }
       /deep/.el-step__icon-inner[class*=el-icon]:not(.is-status){
               font-size: 10px;
       }
       /deep/.el-step.is-vertical .el-step__title{
            line-height: inherit;
            margin-top: 10px;
            font-weight: bold;
       }
       /deep/.el-step.is-vertical .el-step__icon.is-icon {
            margin-top: 20px;
        }
        /deep/.el-step__title.is-process, /deep/.el-step__description.is-process{
                color: #C0C4CC;
        }

    }
    /deep/.buttonBgd {
      background-color: #78b942;
      border-color: #78b942;
      font-size: 14px;
      margin: 20px 0 20px 60px;
    }

    .dialog-footer {
      margin-top: -20px;
      display: block;
    }
</style>







// WEBPACK FOOTER //
// src/views/auction/auctionOrderDetail.vue